import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
var QuestTabs = function QuestTabs() {
  return import('@/components/organisms/QuestTabs');
};
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
import Nl2br from 'vue-nl2br';
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var CountDown = function CountDown() {
  return import('@/components/molecules/CountDown');
};
var CooperationQuestDepartureModal = function CooperationQuestDepartureModal() {
  return import('@/components/organisms/CooperationQuestDepartureModal');
};
var MultiPageModal = function MultiPageModal() {
  return import('@/components/organisms/MultiPageModal');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var Pager = function Pager() {
  return import('@/components/atoms/Pager');
};
export default {
  components: {
    QuestTabs: QuestTabs,
    PageHeader: PageHeader,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    Modal: Modal,
    CountDown: CountDown,
    CooperationQuestDepartureModal: CooperationQuestDepartureModal,
    MultiPageModal: MultiPageModal,
    RarityIcon: RarityIcon,
    Pager: Pager
  },
  data: function data() {
    return {
      isLoading: false,
      isLoadingPage: false,
      shownCategory: 0,
      departureModalShown: false,
      missionsList: [],
      clickMission: null,
      missionDetail: {},
      receiveRewardMission: 0,
      myMissionStatus: 0,
      cooperationType: 2,
      isFilterModalShown: false,
      filterSettings: {
        targetType: [],
        lvs: {
          minLv: 1,
          maxLv: 5
        }
      },
      landIconUrl: '',
      guildIconUrl: '',
      isRecoveryStaminaAtModalShown: false,
      isAllReceiveRewardModalShown: false,
      dummyShown: true,
      animateOn: false,
      flashAnimateOn: false,
      notReceiveList: [],
      allReceiveResultShown: false,
      finishAllReceiveReward: false,
      receivedMissions: [],
      fmTicket: {},
      countDownFinishMissionsIds: [],
      limit: 0
    };
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    getType: function getType() {
      return useExtensionMaster().getExtensionType;
    },
    getFirstPageData: function getFirstPageData() {
      return useMissionStore().getFirstPageData;
    },
    getMissionCounts: function getMissionCounts() {
      return useMissionStore().getMissionCounts;
    },
    getLimitPerPage: function getLimitPerPage() {
      return usePagerStore().getLimitPerPage;
    },
    getOffset: function getOffset() {
      return usePagerStore().getOffset;
    },
    questTypes: function questTypes() {
      return useQuestStore().getQuestTypes;
    },
    getInputClass: function getInputClass() {
      return {
        'arena__search__input-wrapper--error': this.showError && !this.foundArena,
        'arena__search__input-wrapper--success': this.foundArena
      };
    },
    queryPassword: function queryPassword() {
      return this.$route.query.pw || '';
    },
    user: function user() {
      return this.me || [];
    },
    typeNavigation: function typeNavigation() {
      return [this.$t('common.all'), this.$t('quest.frontierMission.normalFm'), this.$t('quest.frontierMission.landFm')];
    },
    navigation: function navigation() {
      return [this.$t('quest.frontierMission.navigation.participate'), this.$t('quest.frontierMission.navigation.recruitmentClosed'), this.$t('quest.frontierMission.navigation.joinHistory')];
    },
    isJoinShown: function isJoinShown() {
      return this.shownCategory === 0;
    },
    normalNodeTypes: function normalNodeTypes() {
      return useNodeStore().getNodeTypes('normal');
    },
    getNotFullMemberMissions: function getNotFullMemberMissions() {
      var _this = this;
      if (!this.missionsList.length) return [];
      var missionsList = this.$util.clone(this.missionsList);
      if (this.filterSettings.targetType.length) {
        missionsList = missionsList.filter(function (mission) {
          return _this.filterSettings.targetType.includes(mission.missionTargetType);
        });
      }
      missionsList = missionsList.filter(function (mission) {
        return mission.lv >= _this.filterSettings.lvs.minLv && mission.lv <= _this.filterSettings.lvs.maxLv;
      });
      return missionsList;
    },
    getEmptyStr: function getEmptyStr() {
      if (this.shownCategory == 0) {
        return this.$t('quest.frontierMission.emptyStr.noMissions');
      } else if (this.shownCategory == 1) {
        return this.$t('quest.frontierMission.emptyStr.noClosed');
      } else {
        return this.$t('quest.frontierMission.emptyStr.noHistoy');
      }
    },
    maxStamina: function maxStamina() {
      if (!Object.keys(this.myMissionStatus).length) return 0;
      return this.myMissionStatus.maxMissionStamina;
    },
    currentStamina: function currentStamina() {
      if (!Object.keys(this.myMissionStatus).length) return 0;
      return this.myMissionStatus.currentMissionStamina;
    },
    landMaxStamina: function landMaxStamina() {
      if (!Object.keys(this.myMissionStatus).length) return 0;
      return this.myMissionStatus.maxLandMissionStamina;
    },
    landCurrentStamina: function landCurrentStamina() {
      if (!Object.keys(this.myMissionStatus).length) return 0;
      return this.myMissionStatus.currentLandMissionStamina;
    },
    targetType: function targetType() {
      return [{
        id: 0,
        name: this.$t('quest.frontierMission.targetAllShort')
      }, {
        id: 1,
        name: this.$t('quest.frontierMission.targetLandShort')
      }, {
        id: 2,
        name: this.$t('quest.frontierMission.targetGuildShort')
      }];
    },
    filterLvs: function filterLvs() {
      return [{
        id: 1,
        name: '★'
      }, {
        id: 2,
        name: '★★'
      }, {
        id: 3,
        name: '★★★'
      }, {
        id: 4,
        name: '★★★★'
      }, {
        id: 5,
        name: '★★★★★'
      }];
    },
    recoveryAt: function recoveryAt() {
      return this.myMissionStatus.missionStaminaAt;
    },
    landRecoveryAt: function landRecoveryAt() {
      return this.myMissionStatus.landMissionStaminaAt;
    },
    normalNotReceiveList: function normalNotReceiveList() {
      return this.notReceiveList.filter(function (x) {
        return x.cooperationType == 0;
      });
    },
    landNotReceiveList: function landNotReceiveList() {
      return this.notReceiveList.filter(function (x) {
        return x.cooperationType == 1;
      });
    },
    dispNotReceiveList: function dispNotReceiveList() {
      if (this.cooperationType == 0) {
        return this.normalNotReceiveList;
      } else if (this.cooperationType == 1) {
        return this.landNotReceiveList;
      } else {
        return this.notReceiveList;
      }
    },
    winCount: function winCount() {
      var list = this.$util.clone(this.dispNotReceiveList);
      list = list.filter(function (x) {
        return x.result == 1;
      });
      return list.length;
    },
    loseCount: function loseCount() {
      var list = this.$util.clone(this.dispNotReceiveList);
      list = list.filter(function (x) {
        return x.result == 2;
      });
      return list.length;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var fmFilter, mission, targetTypes, lvs, minLv, i, missionList, limit, total, maxPage, guildInfo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.isLoading = true;
            _context.next = 3;
            return _this2.fetchTicket();
          case 3:
            fmFilter = _this2.$localStorage.get('fm-filter') || {};
            if (Object.keys(fmFilter).length) {
              _this2.filterSettings = _this2.$util.clone(fmFilter);
            }
            if (!_this2.$route.query.missionId) {
              _context.next = 16;
              break;
            }
            _context.next = 8;
            return _this2.switchCooperationType(Number(_this2.$route.query.cooperationType));
          case 8:
            _context.next = 10;
            return _this2.switchCategory(Number(_this2.$route.query.category));
          case 10:
            mission = {
              missionId: _this2.$route.query.missionId
            };
            _context.next = 13;
            return _this2.clickMissionItem(mission);
          case 13:
            _this2.$router.push(_this2.localePath('quests-cooperation'));
            _context.next = 32;
            break;
          case 16:
            targetTypes = _this2.filterSettings.targetType;
            lvs = [];
            minLv = _this2.$util.clone(_this2.filterSettings.lvs.minLv);
            for (i = minLv; i <= _this2.filterSettings.lvs.maxLv; i++) {
              lvs.push(i);
            }
            _context.next = 22;
            return useMissionStore().fetchMissionCounts({
              isFull: false,
              cooperationType: 2,
              targetType: [],
              lvs: []
            });
          case 22:
            missionList = useMissionStore().getFilteredMissions({
              isFull: false,
              cooperationType: _this2.cooperationType,
              targetType: targetTypes,
              lvs: lvs
            });
            limit = 20;
            total = missionList.length;
            maxPage = Math.ceil(total / limit);
            usePagerStore().reset();
            usePagerStore().init({
              total: total,
              max: maxPage,
              limit: limit,
              index: 0
            });
            _this2.fetchMyReceiveList();
            _this2.missionsList = missionList.slice(0, limit);
            _context.next = 32;
            return _this2.fetchStatus();
          case 32:
            if (!(_this2.me.landType != 0)) {
              _context.next = 39;
              break;
            }
            _this2.landIconUrl = "".concat(_this2.$env.staticUrl, "/land/landicon/land_icon_").concat(_this2.me.landType, ".png");
            if (!(_this2.me.guildId > 0)) {
              _context.next = 39;
              break;
            }
            _context.next = 37;
            return _this2.$landGuildService.GetGuildInfo(_this2.me.guildId);
          case 37:
            guildInfo = _context.sent;
            if (guildInfo.ipfs.includes('.png')) _this2.guildIconUrl = "".concat(_this2.$env.cdnUrl, "/static/land/guildicon/").concat(guildInfo.ipfs);else _this2.guildIconUrl = "".concat(_this2.$env.cdnUrl, "/user_arts/").concat(guildInfo.ipfs);
          case 39:
            _this2.isLoading = false;
          case 40:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchMyInfo: function fetchMyInfo() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$questsService.getMissionStatus();
            case 2:
              _this3.myMissionStatus = _context2.sent;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchData: function fetchData(offset, limit) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var targetTypes, lvs, minLv, i, isFull, missionList, myMissionList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isLoadingPage = true;
              targetTypes = _this4.filterSettings.targetType;
              lvs = [];
              minLv = _this4.$util.clone(_this4.filterSettings.lvs.minLv);
              for (i = minLv; i <= _this4.filterSettings.lvs.maxLv; i++) {
                lvs.push(i);
              }
              isFull = false;
              if (_this4.shownCategory == 1) {
                isFull = true;
                targetTypes = [];
                lvs = [];
              }
              if (!(_this4.shownCategory != 2)) {
                _context3.next = 14;
                break;
              }
              _context3.next = 10;
              return _this4.$questsService.getPublicMissionInfos(_this4.cooperationType, isFull, offset, limit, targetTypes, lvs);
            case 10:
              missionList = _context3.sent;
              _this4.missionsList = missionList.missionInfosList;
              _context3.next = 19;
              break;
            case 14:
              if (!(_this4.shownCategory == 2)) {
                _context3.next = 19;
                break;
              }
              _context3.next = 17;
              return _this4.$questsService.getMyMissionInfos(_this4.cooperationType, offset, limit);
            case 17:
              myMissionList = _context3.sent;
              _this4.missionsList = myMissionList.missionInfosList;
            case 19:
              _context3.next = 21;
              return _this4.fetchStatus();
            case 21:
              _this4.isLoadingPage = false;
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchStatus: function fetchStatus() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var hostUids;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.fetchMyInfo();
              hostUids = _this5.missionsList.map(function (mission) {
                return mission.ownerId;
              });
              useUserStore().fetchUsers(hostUids);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    resetData: function resetData() {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var index, limit, total, maxPage;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              index = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 0;
              limit = 20;
              _context5.next = 4;
              return _this6.fetchMissinonCounts();
            case 4:
              total = _context5.sent;
              maxPage = Math.ceil(total / limit);
              usePagerStore().reset();
              usePagerStore().init({
                total: total,
                max: maxPage,
                limit: limit,
                index: index
              });
              _this6.fetchMyReceiveList();
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchMyReceiveList: function fetchMyReceiveList() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var myMissionAllList, mission;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$questsService.getMyMissionInfos(_this7.cooperationType, 0, 1);
            case 2:
              myMissionAllList = _context6.sent;
              _this7.receiveRewardMission = 0;
              if (myMissionAllList.missionInfosList.length) {
                mission = myMissionAllList.missionInfosList[0];
                if (!_this7.isOrganization(mission) && !(mission.viewStatus == 2 && mission.result == 2) && (!mission.winRewardDropsMap.length || !!mission.winRewardDropsMap.length && mission.winRewardDropsMap[0][1].mintedId == 0)) {
                  _this7.receiveRewardMission = 1;
                }
              }
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchMissinonCounts: function fetchMissinonCounts() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var counts, targetTypes, lvs, minLv, i;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              counts = 0;
              targetTypes = _this8.filterSettings.targetType;
              lvs = [];
              minLv = _this8.$util.clone(_this8.filterSettings.lvs.minLv);
              for (i = minLv; i <= _this8.filterSettings.lvs.maxLv; i++) {
                lvs.push(i);
              }
              if (!(_this8.shownCategory == 0)) {
                _context7.next = 11;
                break;
              }
              _context7.next = 8;
              return useMissionStore().fetchMissionCounts({
                isFull: false,
                cooperationType: _this8.cooperationType,
                targetType: targetTypes,
                lvs: lvs
              });
            case 8:
              if (_this8.cooperationType == 0) {
                counts = _this8.getMissionCounts.normalCounts ? _this8.getMissionCounts.normalCounts : 0;
              } else if (_this8.cooperationType == 1) {
                counts = _this8.getMissionCounts.landCounts ? _this8.getMissionCounts.landCounts : 0;
              } else if (_this8.cooperationType == 2) {
                counts = _this8.getMissionCounts.allCounts ? _this8.getMissionCounts.allCounts : 0;
              }
              _context7.next = 21;
              break;
            case 11:
              if (!(_this8.shownCategory == 1)) {
                _context7.next = 17;
                break;
              }
              _context7.next = 14;
              return useMissionStore().fetchMissionCounts({
                isFull: true,
                cooperationType: _this8.cooperationType,
                targetType: targetTypes,
                lvs: lvs
              });
            case 14:
              if (_this8.cooperationType == 0) {
                counts = _this8.getMissionCounts.normalFullCounts ? _this8.getMissionCounts.normalFullCounts : 0;
              } else if (_this8.cooperationType == 1) {
                counts = _this8.getMissionCounts.landFullCounts ? _this8.getMissionCounts.landFullCounts : 0;
              } else if (_this8.cooperationType == 2) {
                counts = _this8.getMissionCounts.allFullCounts ? _this8.getMissionCounts.allFullCounts : 0;
              }
              _context7.next = 21;
              break;
            case 17:
              if (!(_this8.shownCategory == 2)) {
                _context7.next = 21;
                break;
              }
              _context7.next = 20;
              return useMissionStore().fetchMyMissionCount(_this8.cooperationType);
            case 20:
              if (_this8.cooperationType == 0) {
                counts = _this8.getMissionCounts.myNormalMissionCounts ? _this8.getMissionCounts.myNormalMissionCounts : 0;
              } else if (_this8.cooperationType == 1) {
                counts = _this8.getMissionCounts.myLandMissionCounts ? _this8.getMissionCounts.myLandMissionCounts : 0;
              } else if (_this8.cooperationType == 2) {
                counts = _this8.getMissionCounts.myAllMissionCounts ? _this8.getMissionCounts.myAllMissionCounts : 0;
              }
            case 21:
              return _context7.abrupt("return", counts);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    switchCategory: function switchCategory(newCategory) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.isLoading = true;
              _this9.shownCategory = newCategory;
              if (_this9.$route.query.page) {
                _context8.next = 10;
                break;
              }
              _context8.next = 5;
              return _this9.resetData();
            case 5:
              _this9.missionsList = _this9.shownCategory == 2 ? _this9.getFirstPageData : useMissionStore().getMissions.slice(0, 20);
              _context8.next = 8;
              return _this9.fetchStatus();
            case 8:
              _context8.next = 14;
              break;
            case 10:
              _context8.next = 12;
              return _this9.resetData(Number(_this9.$route.query.page));
            case 12:
              _context8.next = 14;
              return _this9.fetchData(_this9.getOffset, _this9.getLimitPerPage);
            case 14:
              _this9.isLoading = false;
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getFrameSrc: function getFrameSrc(attribute) {
      return require("~/assets/images/frames/".concat(attribute, ".png"));
    },
    getNow: function getNow() {
      return Math.round(new Date().getTime() / 1000);
    },
    clickMissionItem: function clickMissionItem(mission) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.$questsService.getMissionInfo(mission.missionId);
            case 2:
              _this10.missionDetail = _context9.sent;
              _this10.clickMission = _this10.missionDetail;
              _this10.departureModalShown = true;
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    isJoined: function isJoined(mission) {
      return mission.uidsList.includes(this.me.uid);
    },
    isOrganization: function isOrganization(mission) {
      return mission.status === this.$constants.MISSION_STATUS.ORGANIZATION_STATUS;
    },
    canNotJoin: function canNotJoin(mission) {
      return !this.isOrganization(mission) || this.shownCategory != 0 || this.isJoined(mission);
    },
    switchCooperationType: function switchCooperationType(index) {
      var _arguments2 = arguments,
        _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var tab;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              tab = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
              _this11.isLoading = true;
              if (tab) {
                if (index == 0) {
                  _this11.cooperationType = 2;
                } else if (index == 1) {
                  _this11.cooperationType = 0;
                } else {
                  _this11.cooperationType = 1;
                }
              } else {
                _this11.cooperationType = index;
              }
              if (_this11.$route.query.page) {
                _context10.next = 10;
                break;
              }
              _this11.receiveRewardMission = 0;
              _context10.next = 7;
              return _this11.resetData();
            case 7:
              _this11.missionsList = _this11.shownCategory == 2 ? _this11.getFirstPageData : useMissionStore().getMissions.slice(0, 20);
              _context10.next = 10;
              return _this11.fetchStatus();
            case 10:
              _this11.isLoading = false;
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    isActiveCooperationType: function isActiveCooperationType(index) {
      if (index == 0 && this.cooperationType == 2) {
        return true;
      } else if (index == 1 && this.cooperationType == 0) {
        return true;
      } else if (index == 2 && this.cooperationType == 1) {
        return true;
      }
      return false;
    },
    toggleFilter: function toggleFilter(category, id) {
      if (this.filterSettings[category].includes(id)) {
        var index = this.filterSettings[category].indexOf(id);
        this.filterSettings[category].splice(index, 1);
      } else {
        this.filterSettings[category].push(id);
      }
    },
    isSelected: function isSelected(category, id) {
      var filteredCategory = this.filterSettings[category] || [];
      return filteredCategory.includes(id);
    },
    closeFilerModal: function closeFilerModal() {
      this.isFilterModalShown = false;
      this.filterSettings = this.$util.clone(this.filterSettings);
    },
    filterList: function filterList() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this12.resetData();
            case 2:
              _this12.missionsList = _this12.shownCategory == 2 ? _this12.getFirstPageData : useMissionStore().getMissions.slice(0, 20);
              _context11.next = 5;
              return _this12.fetchStatus();
            case 5:
              _this12.isFilterModalShown = false;
              _this12.$localStorage.set('fm-filter', _this12.filterSettings);
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    getLandClass: function getLandClass(mission) {
      if (mission.cooperationType == 1) {
        if (mission.missionTargetLandType == 1) {
          return 'mission_landType_agni';
        } else if (mission.missionTargetLandType == 2) {
          return 'mission_landType_sama';
        } else if (mission.missionTargetLandType == 3) {
          return 'mission_landType_vriksha';
        } else if (mission.missionTargetLandType == 4) {
          return 'mission_landType_atharva';
        } else if (mission.missionTargetLandType == 5) {
          return 'mission_landType_laVeda';
        } else if (mission.missionTargetLandType == 6) {
          return 'mission_landType_bariura';
        }
      }
      return 'mission_landType_none';
    },
    viewAllReceiveResult: function viewAllReceiveResult() {
      this.allReceiveResultShown = true;
    },
    allReceiveReward: function allReceiveReward() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var missions;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              try {
                missions = [];
                if (_this13.cooperationType == 0) missions = _this13.$util.clone(_this13.normalNotReceiveList);
                if (_this13.cooperationType == 1) missions = _this13.$util.clone(_this13.landNotReceiveList);
                if (_this13.cooperationType == 2) missions = _this13.$util.clone(_this13.notReceiveList);
                missions.forEach(function (mission) {
                  if (mission.foundRewardDropsMap.length && mission.foundRewardDropsMap[0][1].treasureType == 3 || mission.winRewardDropsMap.length && mission.winRewardDropsMap[0][1].treasureType == 3) {
                    _this13.animateOn = true;
                  }
                });
                _this13.finishAllReceiveReward = true;
              } catch (e) {
                _this13.$toast.error('Error.');
                console.log(e);
              }
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    allReceiveRewardModalClose: function allReceiveRewardModalClose() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var missions, missionIds;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this14.animateOn = false;
              _this14.flashAnimateOn = false;
              _this14.dummyShown = true;
              if (!(_this14.finishAllReceiveReward || _this14.winCount == 0)) {
                _context13.next = 18;
                break;
              }
              _this14.isLoading = true;
              missions = [];
              if (_this14.cooperationType == 0) missions = _this14.$util.clone(_this14.normalNotReceiveList);
              if (_this14.cooperationType == 1) missions = _this14.$util.clone(_this14.landNotReceiveList);
              if (_this14.cooperationType == 2) missions = _this14.$util.clone(_this14.notReceiveList);
              missionIds = [];
              missions.forEach(function (mission) {
                missionIds.push(mission.missionId);
              });
              _context13.next = 13;
              return _this14.$questsService.receiveMissionRewards(missionIds);
            case 13:
              _this14.receivedMissions = _context13.sent;
              _context13.next = 16;
              return _this14.fetchData(_this14.getOffset, _this14.getLimitPerPage);
            case 16:
              _this14.fetchMyReceiveList();
              _this14.isLoading = false;
            case 18:
              _this14.allReceiveResultShown = false;
              _this14.finishAllReceiveReward = false;
              _this14.isAllReceiveRewardModalShown = false;
            case 21:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    rewardChestSrc: function rewardChestSrc(treasureType) {
      if (treasureType == 3) {
        return this.$env.staticUrl + '/box0_close.png';
      } else if (treasureType == 2) {
        return this.$env.staticUrl + '/box1_close.png';
      } else {
        return this.$env.staticUrl + '/box2_close.png';
      }
    },
    foundRewardList: function foundRewardList(type) {
      if (type == 'normal') {
        return this.normalNotReceiveList.filter(function (mission) {
          return mission.result == 1 && mission.foundRewardDropsMap.length != 0;
        });
      } else if (type == 'land') {
        return this.landNotReceiveList.filter(function (mission) {
          return mission.result == 1 && mission.foundRewardDropsMap.length != 0;
        });
      }
      return [];
    },
    winRewardList: function winRewardList(type) {
      if (type == 'normal') {
        return this.normalNotReceiveList.filter(function (mission) {
          return mission.result == 1 && mission.winRewardDropsMap.length != 0;
        });
      } else if (type == 'land') {
        return this.landNotReceiveList.filter(function (mission) {
          return mission.result == 1 && mission.winRewardDropsMap.length != 0;
        });
      }
      return [];
    },
    getRewardItem: function getRewardItem(mission, type) {
      var rewardType = type == 'found' ? mission.foundRewardDropsMap[0][1].rewardType : mission.winRewardDropsMap[0][1].rewardType;
      var rewardId = type == 'found' ? mission.foundRewardDropsMap[0][1].rewardId : mission.winRewardDropsMap[0][1].rewardId;
      var item = null;
      //- スフィア
      if (rewardType == 100) {
        item = this.getType(rewardId);
        if (item) item.imgSrc = "".concat(this.$env.cdnUrl, "/rsc/sphere/").concat(item.extensionType, ".png");
        //- インゴット
      } else if (rewardType == 200) {
        item = useConsumableMaster().getExpItem(rewardId);
        if (item) item.imgSrc = "".concat(this.$env.cdnUrl, "/rsc/landitem/").concat(item.filename, ".png");
        //- 期限つきアイテム
      } else if (rewardType == 201) {
        item = useConsumableMaster().getLimitedItem(rewardId);
        if (item) item.imgSrc = "".concat(this.$env.cdnUrl, "/rsc/item/time_limited_item/").concat(item.filename, ".png");
        //- 消費アイテム
      } else if (rewardType == 202) {
        item = useConsumableMaster().getConsumeItem(rewardId);
        if (item) item.imgSrc = "".concat(this.$env.cdnUrl, "/rsc/item/consume_item/").concat(item.filename, ".png");
        //- オーブ
      } else if (rewardType == 203) {
        item = useConsumableMaster().getExtensionExpItem(rewardId);
        if (item) item.imgSrc = "".concat(this.$env.cdnUrl, "/rsc/item/extension_exp_item/").concat(item.filename, ".png");
      }
      return item;
    },
    fetchTicket: function fetchTicket() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return useConsumableStore().fetchConsumeMyItems();
            case 2:
              _this15.fmTicket = useConsumableStore().getConsumeMyItems.find(function (x) {
                return x.consumeItemId == 1101;
              });
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    allReceiveModalShown: function allReceiveModalShown() {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var myMissionAllList;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this16.$questsService.getMyMissionInfos(_this16.cooperationType, 0, 10000);
            case 2:
              myMissionAllList = _context15.sent;
              _this16.notReceiveList = myMissionAllList.missionInfosList.filter(function (mission) {
                return !_this16.isOrganization(mission) && !(mission.viewStatus == 2 && mission.result == 2) && (!mission.winRewardDropsMap.length || !!mission.winRewardDropsMap.length && mission.winRewardDropsMap[0][1].mintedId == 0);
              });
              _this16.isAllReceiveRewardModalShown = true;
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    getEnemyType: function getEnemyType(enemyType) {
      return useEnemyMaster().getEnemyType(enemyType);
    },
    loadMore: function loadMore() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (_this17.limit) {
                _context16.next = 3;
                break;
              }
              _this17.limit = _this17.$device.isMobile ? 3 : 8;
              return _context16.abrupt("return");
            case 3:
              if (!(_this17.limit > 20)) {
                _context16.next = 5;
                break;
              }
              return _context16.abrupt("return");
            case 5:
              _this17.limit += 3;
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    }
  }
};